import CTA from "../cta/v1";

import { footerLinksV1 } from "../../../assets/data/insiteLinks";
import { FooterStyleWrapper, StyledLogo } from "./Footer.style";
import BackToTop from "../../../assets/images/icon/back_to_top";

const Footer = ({ variant }) => {
  let headerStyles;

  switch (variant) {
    case "homev2":
      headerStyles = "#efb90b";
      break;
    case "homev3":
      headerStyles = "#773ddd";
      break;
    default:
      headerStyles = "#0052ff";
  }
  return (
    <FooterStyleWrapper>
      <div className="hermes_v1_main_footer">
        <CTA />
        <div className="footer_bottom">
          <div className="footer_bottom_content">
            <div className="container">
              <div className="footer_menu">
                <div className="bottom_footer_left">
                  <div className="footer_logo">
                    <a href="# ">
                      <StyledLogo variant={headerStyles}/>
                    </a>
                  </div>
                  <div className="copiright_text">
                    <p>Copyright © 2023</p>
                  </div>
                </div>
                <div className="bottom_footer_right">
                  <ul>
                    {footerLinksV1?.map((item, i) => (
                      <li key={i}>
                        <a href={item.url}>{item.title}</a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <a href="# " className="bact_to_top_btn">
                <BackToTop />
              </a>
            </div>
          </div>
        </div>
      </div>
    </FooterStyleWrapper>
  );
};

export default Footer;
